export const FETCH_BANNER = "fetch_banner";
export const FETCH_BANNERS = "fetch_banners";
export const FETCH_USER = "fetch_user";
export const FETCH_RETAILERS = "fetch_retailers";
export const FETCH_ADVERTISERS = "fetch_advertisers";
export const FETCH_RETAILER = "fetch_retailer";
export const FETCH_ADVERTISER = "fetch_advertiser";
export const FETCH_BANNER_TYPE = "fetch_banner_type";
export const FETCH_CURRENTADVERTISER = "fetch_current_advertiser";
export const FETCH_ADNUMBER = "fetch_adnumber";
export const FETCH_BANNER_ID = "fetch_banner_id";
export const OPEN_MODAL = "open_modal";
export const CLOSE_MODAL = "close_modal";
export const SET_DIV_CLASS = "set_div_class";
export const CLEAR_SEARCH = "clear_search";
export const FETCH_TOTAL = "fetch_total";
export const FETCH_PAGE = "fetch_page";
export const FETCH_ERROR = "fetch_error";
export const CLEAR_ERROR = "clear_error";
export const FETCH_TEMPLATES = "fetch_templates";
export const FETCH_TEMPLATE = "fetch_template";
export const FASTRADE = "fastrade";
export const FETCH_ORDERS = "fetch_orders";
export const FETCH_LINE_ITEMS = "fetch_line_items";
export const FETCH_AD_DATA = "fetch_ad_data";
export const CLEAR_AD_DATA = "clear_ad_data";
export const FETCH_AD_REQUEST = "fetch_ad_request";
export const FETCH_SEARCH_RESULTS = "fetch_search_results";
export const FETCH_SKU_SEARCH = "fetch_sku_search";
export const CLEAR_SKU_SEARCH = "clear_sku_search";
export const FETCH_RANGE_SEARCH = "fetch_range_search";
export const CLEAR_RANGE_SEARCH = "clear_range_search";
export const FETCH_PRODUCT_IMAGE = "fetch_product_image";
export const SIZE_TO_FIT = "size_to_fit";
